import React from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone'
import { compose, lifecycle, withState } from 'recompose'
import { Input, Button, TextArea, Dropdown, Icon,Label, Checkbox } from 'semantic-ui-react'
import { Field } from 'redux-form'
import r from 'reactotron-react-js'

import { toastError } from '../../../ducks/app'
import { FileUploadCell } from '../../../components'
import {
  FiledRowContent,
  DropzoneContainer,
  UploadFileContainer
} from './styled'

export const renderInputText = ({ input,style,disabled, meta: { touched, error, warning } }) => {
  return (
    <FiledRowContent>
      <Input {...input} style={style||{}} disabled={disabled||false} className='field-input' type='text' autoComplete='off' />
      <div className='field-label'>
        {touched &&
          ((error && <span className='error'>{error}</span>) ||
            (warning && <span className='error'>{warning}</span>)
          )}
      </div>
    </FiledRowContent>
  )
}

export const renderTextArea = ({ input, meta: { touched, error, warning } }) => {
  return (
    <FiledRowContent>
      <TextArea className='field-input' {...input} rows={3} />
      <div className='field-label'>
        {touched &&
          ((error && <span className='error'>{error}</span>) ||
            (warning && <span className='error'>{warning}</span>)
          )}
      </div>
    </FiledRowContent>
  )
}

export const renderCheckbox = props => {
  const { input, meta: { touched, error, warning } } = props
  return (
    <div style={{flex:1}}>
      <Checkbox {...input} toggle defaultChecked />
    </div>
  )
}

export const renderDropdown = props => {
  const { fields,data, meta: { touched, error, warning } } = props
  return (
    <FiledRowContent>
      <Dropdown 
        selection
        value={props.input.value}
        fluid
        search
        onChange={(param,data) => {props.input.onChange(data.value)}}
        placeholder={props.label} 
        options={props.option}
      />
      <div className='field-label'>
        {touched &&
          ((error && <span className='error'>{error}</span>) ||
            (warning && <span className='error'>{warning}</span>)
          )}
      </div>
    </FiledRowContent>
  )
}

export const renderFileView = ({ fields,data, meta: { touched, error, warning } }) => {
  return (
    <div style={{marginBottom:10}}>
      {fields.map((file,i)=>{
        if(data[i].size>0&&data[i].isDelete===false){
          return (
            <Label key={i} style={{marginTop:5}}>
              <Icon size='small' name='file' /> {data[i].originaFilename} <Icon size='small' style={{marginLeft:10}} name='close' 
                onClick={()=>{
                  let a = JSON.parse(JSON.stringify(data[i]))
                  a.isDelete = true
                  fields.splice(i, 0, a)
                  fields.remove(i+1)
                }}/>
            </Label>
          )
        } else if(data[i].size>0&&data[i].isDelete){
          return (
            <Label key={i} color='red' style={{marginTop:5}}>
              <Icon size='small' color='yellow' name='trash' /> {data[i].originaFilename} <Icon size='small' style={{marginLeft:10}} name='redo' 
                onClick={()=>{
                  console.log(data)
                  let a = JSON.parse(JSON.stringify(data[i]))
                  a.isDelete = false
                  fields.splice(i, 0, a)
                  fields.remove(i+1)
                  console.log(data)
                }}/>
            </Label>
          )
        }
      })}
    </div>
  )
}

export const renderArrayUrl = ({fields,addActive,documentType,data, meta: { touched, error, warning } }) => {
  return (
    <div style={{display:'flex',flex:6,flexDirection:'column'}}>
        {fields.map((item, index) => {
          if(data&&(data[index].size===0&&!data[index].isDelete)&&data[index].id!==0){
            return(
              <div key={index} style={{display:'flex',alignItems:'first baseline'}}>
                <Field
                  name={`${item}.urlPath`}
                  component={renderInputText}
                />
                <Icon link name='delete' onClick={()=>{
                    let a = JSON.parse(JSON.stringify(data[index]))
                    a.isDelete = true
                    fields.splice(index, 0, a)
                    fields.remove(index+1)
                  }}/>
              </div>)
          }else if(data&&(data[index].size===0&&data[index].isDelete)&&data[index].id!==0){
            return(
              <div key={index} style={{display:'flex',alignItems:'first baseline'}}>
                <Field
                  name={`${item}.urlPath`}
                  disabled={true}
                  style={{textDecoration: 'line-through'}}
                  component={renderInputText}
                />
                <Icon link name='redo' onClick={()=>{
                    let a = JSON.parse(JSON.stringify(data[index]))
                    a.isDelete = false
                    fields.splice(index, 0, a)
                    fields.remove(index+1)
                  }}/>
              </div>)
          }else if(!data||data[index].size===0){
            return(
              <div key={index} style={{display:'flex',alignItems:'first baseline'}}>
                <Field
                  name={`${item}.urlPath`}
                  component={renderInputText}
                />
                <Icon link name='delete' onClick={()=>{fields.remove(index)}}/>
              </div>)
          }
        })}
      {(addActive||false)&&
      <Button style={{width:80}} size='mini' type="button" 
        onClick={() => fields.push({
          id: 0,
          productId: 0,
          filename: '',
          originaFilename: '',
          size: 0,
          filetype: '',
          isDelete:false,
          documentType: documentType,
          urlPath: ''})}>
        Add Url
      </Button>}
      {error && <li className="error">{error}</li>}
    </div>
  )
}

export const renderFileDropzone = ({ input, documentType, title, files, multiple, require, meta: { touched, error, warning } }) => {
  const uploadFiles = input.value || files
  return (
    <UploadFileContainer>
      <div style={{flex:3}} className='content'>
        <div className='dropzoneTitle'>
          {title} 
          <span className='errorMessage'>
            {require ? ' * ' : ' '}
            {error}
          </span>
        </div>
        <Dropzone
          accept='application/pdf, image/png, image/jpg'
          multiple={multiple}
          onDrop={
            acceptedFiles => {
              acceptedFiles.forEach(file => {
                const reader = new FileReader()
                reader.onload = () => {
                  multiple ?
                    input.onChange([...uploadFiles, {
                      ID: 0,
                      ProductID: 0,
                      Filename: file.name,
                      OriginaFilename: file.name,
                      Size: file.size,
                      Filetype: file.type,
                      DocumentType: documentType,
                      FileStream:reader.result.split('base64,')[1],
                      UrlPath: '',
                      IsDelete:false
                    }]) :
                    input.onChange([{
                      ID: 0,
                      ProductID: 0,
                      Filename: file.name,
                      OriginaFilename: file.name,
                      Size: file.size,
                      Filetype: file.type,
                      DocumentType: documentType,
                      FileStream:reader.result.split('base64,')[1],
                      UrlPath: '',
                      IsDelete:false
                    }])
                }
                reader.onabort = () => toastError('file reading was aborted')
                reader.onerror = () => toastError('file reading has failed')

                reader.readAsDataURL(file)
              })
            }}>
          {({ getRootProps, getInputProps, isDragActive }) => {
            return (
              <div
                {...getRootProps()}
                className={classNames('dropzone', { 'dropzone--isActive': isDragActive })}
              >
                <input {...getInputProps()} />
                <DropzoneContainer>
                  <div className='textTitle'><Icon name='upload' /> Drag file to upload</div>
                  <div className='textTitle'>Or</div>
                  <div className='buttonUI'>Choose File</div>
                </DropzoneContainer>
              </div>
            )
          }}
        </Dropzone>
        {uploadFiles&&
          uploadFiles.map((d, index) => 
            <FileUploadCell
              fileName={`${d.OriginaFilename}`}
              fileSize={d.Size / 1024}
              onClickDelete={() => {
                var clone = JSON.parse(JSON.stringify(uploadFiles));
                clone.splice(index, 1)
                input.onChange([...clone])
              }} />
          )
        }
      </div>
    </UploadFileContainer>
  )
}